import { Grid } from '@mui/material';
import styled from 'styled-components';
import { color } from '../../theme/Color';

export const GridContainer = styled(Grid)`
  & .kpiStaticText {
    color: ${({ mode }) =>
      mode === 'light' ? `${color._616161}` : `${color._c4c4c4}`};
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
  }

  & .kpiSubtitle {
    font-family: Inter;
    color: ${({ mode }) =>
      mode === 'light' ? `${color._616161}` : `${color._d0d0d0}`};
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    width: fit-content;
    border-radius: 4px;
    text-align: center;
  }
`;

export const MainContainer = styled.div`
  & .chartContainer {
    background: ${({ mode }) =>
      mode === 'light'
        ? `${color._FBFCFE} !important`
        : `${color._1d1d1d} !important`};
    border-radius: 8px;
    margin-top: 16px;
    position: relative;
    border: ${({ mode }) =>
      mode === 'light' ? `1px solid ${color._D7E5F8}` : ' '};
  }
  & .mobileDrawerIcon {
    text-align: right;
  }
  & .desktopDrawerIcon {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  & .metricsDivider {
    border-width: 1px;
    background: ${({ mode }) =>
      mode === 'light' ? color._B2CAEA : color._3a3a3a};
    margin-top: 32px;
    margin-bottom: 32px;
  }
`;
